export interface EResourceReturnResponse {
    success: boolean;
    message: string;
}

export interface EResourceCheckout {
    service: String;
    titleId: String;
    patronId: String;
    format: String;
}

export enum EResourceService {
    overdrive = "overdrive",
    bakertaylor = "bakertaylor",
    mackin = "mackin",
}